import { render } from "./PayRecordPage.vue?vue&type=template&id=4827639e&scoped=true"
import script from "./PayRecordPage.vue?vue&type=script&lang=js"
export * from "./PayRecordPage.vue?vue&type=script&lang=js"

import "./PayRecordPage.vue?vue&type=style&index=0&id=4827639e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4827639e"]])

export default __exports__